import type { JSX } from 'react'

export const ArrowLeftIcon = (): JSX.Element => (
  <use href='#arrowLeftIcon' height='100%' width='100%' />
)
